export const raQuotes = {
  unlock: {
    id: 0,
    lines: [
      "... Посетитель?",
      "Я здесь! Я - тот, кого ты ищешь... Я думаю...",
      "Что Я вообще такое?",
      "Ах, точно, Божество Воспоминаний.",
    ]
  },
  realityEnter: {
    id: 1,
    lines: [
      "Я не видел остальных так долго...",
      "Можешь ли ты помочь мне вспомнить их?",
      "Взамен я могу дать тебе способности.",
    ]
  },
  teresaStart: {
    id: 2,
    requirement: () => Ra.pets.teresa.level >= 2,
    lines: [
      "Те... ре... за...",
      "Я думаю я помню.",
    ]
  },
  teresaLate: {
    id: 3,
    requirement: () => Ra.pets.teresa.level >= 15,
    lines: [
      "Я полагаю, Тереза имела дело с машинами.",
      "Я помню как посещал её магазин несколько раз.",
      "Погоди, кто-то другой тоже имел магазин, верно?",
    ]
  },
  effarigStart: {
    id: 4,
    requirement: () => Ra.pets.effarig.level >= 2,
    lines: [
      "Эфф... а... риг",
      "Я помню, что Эффариг был дружелюбен.",
    ]
  },
  effarigLate: {
    id: 5,
    requirement: () => Ra.pets.effarig.level >= 15,
    lines: [
      "Эфариг был очень особенный?",
      "И Я также помню пугающую Реальность...",
      "Она была про... страдание?",
    ]
  },
  enslavedStart: {
    id: 6,
    requirement: () => Ra.pets.enslaved.level >= 2,
    lines: [
      "Я абсолютно не могу вспомнить этого...",
    ]
  },
  enslavedLate: {
    id: 7,
    requirement: () => Ra.pets.enslaved.level >= 15,
    lines: [
      "Я начинаю вспоминать...",
      "Зачем я здесь...",
      "Почему я один...",
      "Помоги мне.",
    ]
  },
  vStart: {
    id: 8,
    requirement: () => Ra.pets.v.level >= 2,
    lines: [
      "Встречал ли я его?",
      "Одинокий, но при этом такой...",
    ]
  },
  vLate: {
    id: 9,
    requirement: () => Ra.pets.v.level >= 15,
    lines: [
      "Я думаю я встречался с Ви однажды...",
      "Я могу вспомнить достижения.",
    ]
  },
  remembrance: {
    id: 10,
    requirement: () => Ra.remembrance.isUnlocked,
    lines: [
      "Я вспомнил кое-что!",
      "Смотри!",
      "Вспоминаемость!",
      "Теперь Я могу фокусироваться ещё сильнее на их вспоминании!",
    ]
  },
  midMemories: {
    id: 11,
    requirement: () => Ra.totalPetLevel >= 50,
    lines: [
      "Реальности - мои дома, но Я не могу создать свою собственную Реальность.",
      "Я могу лишь копировать Реальности своих друзей.",
      "Но... почему Я слышу голоса?",
      "Они просят о помощи?",
    ]
  },
  lateMemories: {
    id: 12,
    requirement: () => Ra.totalPetLevel >= 80,
    lines: [
      "Я думаю они говорят мне остановиться.",
      "Ты... что ты такое?",
      "Что происходит?",
      "Я делаю что-то не то?",
    ]
  },
  maxLevels: {
    id: 13,
    requirement: () => Ra.totalPetLevel === Ra.maxTotalPetLevel,
    lines: [
      "Наконец, Я помню всё.",
      "Эту темноту, изгнавшую меня.",
      "Лай'тела...",
      "Он был прав, когда изгнал меня.",
      "Мои силы...",
      "Они воруют, они вредят.",
      "Пожалуйста уходи.",
      "Я не хочу навредить и тебе тоже.",
    ]
  },
};
